import React, { Component } from 'react';


class Paper extends Component {
    render(){
        return (
            <div id="folha" className="col-12">
	            <div className="row">
	                <div className="col-12 sombra">
	                &nbsp;
	                </div>
	            </div>
	        </div>
        );
    }
}

export default Paper;